var _mask, _path, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4202 0H2C0.895431 0 0 0.89543 0 2V20C0 21.1046 0.89543 22 2 22H15C16.1046 22 17 21.1046 17 20V3.27692L13.4202 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4202 0L14.0954 -0.737625L13.8088 -1H13.4202V0ZM17 3.27692H18V2.83661L17.6752 2.5393L17 3.27692ZM2 1H13.4202V-1H2V1ZM1 2C1 1.44772 1.44771 1 2 1V-1C0.343146 -1 -1 0.343145 -1 2H1ZM1 20V2H-1V20H1ZM2 21C1.44772 21 1 20.5523 1 20H-1C-1 21.6569 0.343145 23 2 23V21ZM15 21H2V23H15V21ZM16 20C16 20.5523 15.5523 21 15 21V23C16.6569 23 18 21.6569 18 20H16ZM16 3.27692V20H18V3.27692H16ZM17.6752 2.5393L14.0954 -0.737625L12.745 0.737625L16.3248 4.01455L17.6752 2.5393Z",
    fill: "#2C2E3E",
    mask: "url(#path-1-inside-1)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 7.5,
    x2: 12.5,
    y2: 7.5,
    stroke: "#2C2E3E",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 11.5,
    x2: 12.5,
    y2: 11.5,
    stroke: "#2C2E3E",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 15.5,
    x2: 8.5,
    y2: 15.5,
    stroke: "#2C2E3E",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesc);
export default __webpack_public_path__ + "static/media/desc.b8cdde2a.svg";
export { ForwardRef as ReactComponent };